import { useCallback, useEffect, useState } from "react";

const usePagination = (
  data: any[],
  itemsPerPage: number,
  initialPage: number = 1,
  pageChangeCallback?: (arg: number | undefined) => void,
) => {

  useEffect(() => {
    setCurrentPage(initialPage);
  }, [initialPage]);

  const [currentPage, setCurrentPage] = useState(initialPage);

  const maxPage = Math.ceil(data.length / itemsPerPage);

  const getCurrentData = () => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    return data.slice(start, end);
  };

  const setNextPage = () => {
    setCurrentPage((currentPage) => {
      const newPage = Math.min(currentPage + 1, maxPage);

      if (pageChangeCallback) {
        pageChangeCallback(newPage);
      }
      return newPage;
    });
  };

  const setPrevPage = () => {
    setCurrentPage((currentPage) => {
      const newPage = Math.max(currentPage - 1, 1);
      if (pageChangeCallback) {
        pageChangeCallback(newPage === 1 ? undefined : newPage);
      }
      return newPage;
    });
  };

  const jumpToPage = useCallback((page: number) => {
    const pageNumber = Math.max(1, page);
    setCurrentPage(() => Math.min(pageNumber, maxPage));
    if (pageChangeCallback) {
      pageChangeCallback(pageNumber === 1 ? undefined : pageNumber);
    }
  }, [maxPage, pageChangeCallback]);

  return { setNextPage, setPrevPage, jumpToPage, getCurrentData, currentPage, maxPage };
};

export default usePagination;
